import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { MailingConfigAccordions } from './mailing-config-accordions/mailing-config-accordions.component'

export const MailingConfigComponent = () => {
  const { formatMessage } = useIntl()

  return (
    <Container>
      <Box bgcolor="common.white" p={4} borderRadius={4}>
        <Typography variant="h4" color="primary" gutterBottom>
          {formatMessage({ id: 'pages.profile.mailing.title' })}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          {formatMessage({ id: 'pages.profile.mailing.subtitle' })}
        </Typography>
        <MailingConfigAccordions />
      </Box>
    </Container>
  )
}
